/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import { ServiceLocator } from "@/services/service.locator";
import { Injector       } from "@angular/core";

export enum ActionType {

  /* - - - project - - - */

  Project_New,
  Project_Create_From,
  Project_Open,
  Project_Close,
  Project_Delete,
  Project_Rename,

  /* - - - help - - - */

  Help_Help,
  Help_FAQ,
  Help_Demos,
  Help_Register,
  Help_About,

  /* - - - window - - - */

  Window_Project,
  Window_Search,
  Window_FileBrowser,
  Window_ScenarioBrowser,
  Window_StringLineViewer,
  Window_Properties,
  Window_Jobs,
  Window_Save_Layout,
  Window_Restore_Default,
  Window_TextEdit,
  Window_JSONEdit,
  Window_WorkBlox,
  Window_Diversion,
  Window_TSO,
  Window_ConnectionViewer,
  Window_KPITable,
  Window_SimpleSim,
  Window_SimpleDebug,

  /* - - - admin - - - */

  Admin_Admin,
  Admin_Users,

  /* - - -  user stuff - - - */

  User_Profile,
  User_Logout,

  /* - - - these actions are just used, not managed by the ActionService */

  Custom_Action
}

/**
 *
 * @class Action
 *
 * @brief an action is Command...but for the GUI.  Any menu, or button, or toolbox button can
 * have an underlying action.  For example "Close Project".  For any given acton there is only
 * every one instance of the action, and it has associated attributes such a label, tool tip,
 * being enabled/active (or not) etc.   The sub-classes of the Action base class define all
 * the specific actions possible.
 *
 * We use the ActionService as the action Factory and Registry; when actions are modified
 * they "save" themselves in the ActionService, which then notifies any watchers of the
 * action that changed.  So if the action is used in a menu or in a toolbar, its presentation
 * can change as needed; for example if a project is closed, then the "Project Close" action
 * should now be disabled...because there is nothing to close.
 *
 * We allow for un-managed actions as well (Custom Action), so that menus and tool bars
 * can include dynamically generated items, for example "recent history".
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class Action {

  /** the id of the alert, used to filter/search by text */
  public key:   string;

  /** the kind of alert in this stream */
  public type:  ActionType = ActionType.Custom_Action;

  /** text to display for action */
  public label: string = 'No Label';

  /** icon to display for action */
  public icon:  string;

  /** hover text or bubble help for action */
  public tip:   string;

  /** standard constructor, allow for partial action to be given */
  constructor(init: any = null) {

    if (init) {

      Object.assign(this, init);
    }

  }

  /* is this action enabled? */
  public enabled() : boolean {

    return true;
  }

  /** implement the action */
  public execute() : boolean {

    return false;
  }

  /** fetch the service injector */
  injector(): Injector {

    return ServiceLocator.injector;
  }

}
